import classNames from "classnames";
import React, { useMemo } from "react";

interface SpinnerProps {
  visible?: boolean;
  className?: string;
}

/**
 * A simple, clean loading spinner.
 * No text, single size, one color - just indicates loading state.
 */
export const Spinner = ({ visible = true, className = "" }: SpinnerProps) => {
  const cssClasses = useMemo(
    () =>
      classNames(
        "flex justify-center items-center w-8 aspect-square text-dark-blue transition-long-in-out",
        className,
        {
          "opacity-0": !visible,
          "opacity-100": visible
        }
      ),
    [visible, className]
  );

  return (
    <div className={cssClasses} role="status" aria-label="Loading">
      <div className="relative w-full aspect-square">
        <svg className="w-full h-auto -rotate-90" viewBox="0 0 120 120">
          <circle
            className="stroke-current opacity-40 transition-all duration-[600ms]"
            style={{
              strokeWidth: "12%",
              fill: "none"
            }}
            cx="60"
            cy="60"
            r="40"
          />
          <circle
            className="animate-spinner stroke-current transition-all duration-[600ms]"
            style={{
              strokeWidth: "12%",
              fill: "none",
              strokeLinecap: "round",
              strokeDasharray: "80%",
              strokeDashoffset: "0%",
              transformOrigin: "center"
            }}
            cx="60"
            cy="60"
            r="40"
          />
        </svg>
      </div>
      <span className="sr-only">Loading</span>
    </div>
  );
};

export default Spinner;
